/**
 * The one line under the reason box on a leave request.
 *
 * The reason is free text, seen by the people who approve the request (decision G2,
 * `DESIGN-payroll.md`). Left to themselves, people type "chemotherapy on Tuesdays" — health
 * data the employer never asked for and then has to justify holding. This line is
 * prevention, not policing: it tells the employee they do not have to explain. The same
 * guidance is in ACCEPTABLE-USE.md for employers. Agreed with Rob 11/09/2026.
 *
 * One string, imported wherever the box appears, so the two never drift apart.
 */
export const LEAVE_REASON_HINT = "Keep it brief — you don't need to give a medical reason.";
